export default __webpack_public_path__ + "static/SuisseIntl-Light-36c445ceec6bd598ec27b1c1f425613a.woff";